interface SkipLinkProps {
  /** Id of the page's <main> (without "#"). */
  target: string;
}

/** Keyboard "Skip to content" link: off-screen until focused (shell.css `.cid-skip-link`). */
export function SkipLink({ target }: SkipLinkProps) {
  return (
    <a className="cid-skip-link" href={`#${target}`}>
      Skip to content
    </a>
  );
}
